export default "__VITE_ASSET__Cz6xtsGs__"